import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';
import SalaryCalculator from './components/SalaryCalculator';
import SeoContent from './components/SeoContent';
import MentionsLegales from './pages/MentionsLegales';
import Confidentialite from './pages/Confidentialite';
import Contact from './pages/Contact';
import APropos from './pages/APropos';
import EvolutionSmic from './pages/EvolutionSmic';

const { FiTrendingUp } = FiIcons;

const navLinks = [
  { to: '/evolution', label: 'Évolution du SMIC' },
  { to: '/a-propos', label: 'À Propos' },
  { to: '/contact', label: 'Contact' },
];

function Layout() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-indigo-100 selection:text-indigo-900 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200/60 sticky top-0 z-50 backdrop-blur-md bg-white/80">
        <div className="max-w-5xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 hover:opacity-80 transition-opacity">
            <div className="w-7 h-7 bg-indigo-600 rounded-lg flex items-center justify-center shadow-inner shadow-indigo-400/20">
              <SafeIcon icon={FiTrendingUp} className="text-white text-sm" />
            </div>
            <h1 className="font-bold text-base tracking-tight text-slate-800">
              salaire-smic<span className="text-slate-400 font-normal">.com</span>
            </h1>
          </Link>

          <nav className="flex items-center gap-1">
            {navLinks.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                className={`text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors ${
                  location.pathname === to
                    ? 'bg-indigo-50 text-indigo-600'
                    : 'text-slate-500 hover:text-slate-800 hover:bg-slate-100'
                }`}
              >
                {label}
              </Link>
            ))}
            <span className="ml-2 text-xs font-semibold text-slate-500 bg-slate-100 px-3 py-1.5 rounded-full">
              2026
            </span>
          </nav>
        </div>
      </header>

      {/* Main */}
      <main className="flex-1 px-4 py-8">
        {isHome && (
          <div className="max-w-5xl mx-auto text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 mb-3">
              Convertisseur de Salaire Brut en Net
            </h2>
            <p className="text-slate-500 text-base max-w-2xl mx-auto">
              Calculez instantanément votre salaire net à partir du brut, ou l'inverse.
              Ajustez votre statut et vos impôts pour voir exactement ce qu'il vous restera à la fin du mois.
            </p>
          </div>
        )}
        <Routes>
          <Route path="/" element={
            <>
              <SalaryCalculator />
              <SeoContent />
            </>
          } />
          <Route path="/evolution" element={<EvolutionSmic />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/a-propos" element={<APropos />} />
        </Routes>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-200 bg-white mt-auto">
        <div className="max-w-5xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} salaire-smic.com — Outil indicatif, non contractuel.
          </p>
          <nav className="flex flex-wrap items-center gap-4 justify-center">
            <Link to="/evolution" className="text-xs text-slate-400 hover:text-indigo-600 transition-colors">Évolution du SMIC</Link>
            <Link to="/mentions-legales" className="text-xs text-slate-400 hover:text-indigo-600 transition-colors">Mentions Légales</Link>
            <Link to="/confidentialite" className="text-xs text-slate-400 hover:text-indigo-600 transition-colors">Confidentialité</Link>
            <Link to="/contact" className="text-xs text-slate-400 hover:text-indigo-600 transition-colors">Contact</Link>
            <Link to="/a-propos" className="text-xs text-slate-400 hover:text-indigo-600 transition-colors">À Propos</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}